<!--
 * @Author: linrui
 * @Date: 2021-12-22 18:44:10
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-09 15:04:07
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/examIndex.vue
-->
<template>
    <div class="exam-index-wrapper">
        <div class="exam-guide-box">
            <div class="exam-text-box">
                <p class="exam-text-title">{{examTextTitle}}</p>
                <div class="video-desc">
                    <!-- <p class="sub-title">{{examSubTitle}}</p> -->
                    <p class="desc" v-html="examDesc"></p>
                </div>
                <!-- <div class="video-desc">
                    <p class="sub-title">{{examSubTitle}}</p>
                    <p class="desc">{{examDesc}}</p>
                </div> -->
            </div>
            <div class="btn">
                <van-button class="up" @click="nextStep">{{btnText}}</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    data() {
        return {
            examTextTitle:'培训及考核说明',
            // examSubTitle:'视频简介',
            examDesc:`<p><span style="font-weight:bold">培训内容共分为三个部分：</span></p>
            <p>一、基金会介绍：公益宗旨、援助项目规模等;</p>
            <p>二、项目介绍：项目背景及援助方案、对象、药品等;</p>
            <p>三、项目医学评估：援助流程、医学材料及医生职责等。</p>
            <br/>
            <p><span style="font-weight:bold">考核要求：</span></p>
            <p><span style="font-weight:bold">•</span>观看完培训视频将有考核，所有答题须全部回答正确。</p>`,
            btnText:'进入培训'
        }
    },
    computed: {
        ...mapState({
            doctorInfo: state => state.doctor.doctorInfo,
        })
    },
    created() {
        if(this.$route.query && this.$route.query.isRecord) {
            this.examTextTitle = '恭喜通过考核！'
            this.examSubTitle = ''
            this.examDesc = `<p style="font-size:18px;text-indent:0;">尊敬的${this.doctorInfo.name}医生:</p><p style="font-size:16px;text-indent:30px;margin-bottom:20px;text-align:justify;text-justify:inter-ideograp">非常感谢您参与由中国初级卫生保健基金会发起的“择美同行--患者援助项目，项目旨在减轻全国转移性非小细胞肺癌（NSCLC)患者的经济负担，帮助所属适应症患者得到持续、规范、有效的治疗，提高患者的生活质量。获知您申请参与“择美同行--患者援助项目"，我们对此感到非常荣幸。作为项目医生，您的患者能否从本项目获益，您将起到关键作用。您的主要工作是接受初保基金会委托对自愿申请的患者进行医学评估和推荐，您的参与将给予患者极大的帮助!感谢您对中国慈善事业的支持!</p><p style="font-size:16px;text-align:right">择美同行项目组</p>`
            this.btnText = '开始备案'
        }
    },

    methods:{
        nextStep() {
            if(this.btnText.includes('培训') || this.btnText.includes('考试')) {
                this.$router.replace({
                    name:'ExamVideo'
                })
            } else {
                this.$router.replace({
                    name:'UnderstandingText'
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
.exam-index-wrapper {
    min-height: 100vh;
    background-image: url('../../assets/zmtx-bg.jpg');
    background-repeat: no-repeat;
    background-size: contain;
    overflow: scroll;
    .exam-guide-box {
        width: 100%;
        min-height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 126px 15px;
        padding-bottom: 3px;

        .exam-text-box {
            padding: 19px 12px;
            border-radius: 8px;
            background-color: rgba(255,255,255,.68);
            text-align: center;
            .exam-text-title {
                font-weight: bold;
                margin-bottom: 15px;
                color: #000;
                font-size: 20px;
            }
            .video-desc {
                margin-bottom: 22px;
                font-size: 16px;
                text-indent: 20px;
                .sub-title {
                    text-indent: 0;
                    margin-bottom: 10px;
                    color: #000;
                    text-align: center;
                }
                .desc {
                    text-align: left;
                    // text-indent: 20px;
                    // color:rgba(0, 0, 0, 0.6);
                }
            }
        }
    }
}
</style>